import Head from "next/head";
import { NextSeo } from "next-seo";
import { buildVodDetailHeadParams } from "~/components/templates/vod/detail/head/utils/build-vod-detail-head-params";
import { useQueryString } from "~/hooks/use-query-string";
import { GetVideoDocument, useGetVideoQuery, type G_GetVideoQuery } from "~/lib/graphql";
import { logger } from "~/lib/logger";
import { useAuth } from "~/provider/auth";
import { getDevice, getPlayDevice } from "~/util/get-device";
import { isBot } from "~/util/is-bot";

type Props = {
  serverData?: G_GetVideoQuery;
};

export const VodDetailHead = (props: Props) => {
  const { serverData } = props;
  const { season, content, spot } = useQueryString();
  const { isLoggedIn } = useAuth();
  const { data: clientData } = useGetVideoQuery({
    skip: !!serverData,
    ssr: isBot(),
    query: GetVideoDocument,
    variables: {
      seasonId: season,
      contentId: content ?? "",
      device: getDevice(),
      playDevice: getPlayDevice(),
      isLoggedIn,
      isContentId: content !== undefined,
    },
    errorPolicy: "all",
  });
  const data = serverData ?? clientData;

  if (!data) return null;

  const headParams = buildVodDetailHeadParams({ video: data.video, content, spot });

  return (
    <>
      {logger.info(`${data.video.id ? (season === data.video.id ? true : headParams?.pageTitle) : "loading..."}`)}
      <NextSeo
        title={headParams.pageTitle}
        description={headParams.pageDescription}
        canonical={headParams.canonicalUrl || headParams.pageCanonicalUrl || "tv.dmm.com/vod/detail/"}
        openGraph={{
          title: headParams.ogpTitle,
          description: headParams.ogpDescription,
          images: [headParams.ogpImage],
          siteName: "DMM TV",
          locale: "ja_JP",
          type: "website",
          url: headParams.ogpUrl,
        }}
        noindex={headParams.isNoIndex}
      />
      <Head>
        {/* TODO(uchida): NextSeoでできればそちらに移行する */}
        {/** @type Website と @type TVSeries の条件分岐に使用する */}
        <script
          key="detail-tv-json-ld"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(headParams.detailTvJsonLd) }}
        />
        <script
          key="detail-bread-json-ld"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(headParams.detailBreadJsonLd) }}
        />
      </Head>
    </>
  );
};
